import { fieldDescription } from "@/lib/attributeReview/fieldDescription";
import {
  asReviewRow,
  type RowInput,
} from "@/lib/attributeReview/reviewRow.types";

import { RequiredStar } from "./RequiredStar";

export function SourceCell({
  row: input,
  isDuplicate,
}: {
  row: RowInput;
  isDuplicate: boolean;
}) {
  const row = asReviewRow(input);
  const description = fieldDescription(input);
  return (
    <div className="min-w-0 space-y-1">
      <button
        type="button"
        className="rounded text-left text-sm font-medium text-slate-900 [overflow-wrap:anywhere] focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 dark:text-slate-100"
      >
        {String(row.sourceAttribute ?? row.id)}
        <RequiredStar level={row.requirementLevel} />
      </button>
      {description && (
        <p className="text-xs text-slate-500 [overflow-wrap:anywhere] dark:text-slate-400">
          {description}
        </p>
      )}
      {isDuplicate && (
        <div className="flex flex-wrap items-center gap-1.5">
          <span className="font-mono text-xs text-slate-500 [overflow-wrap:anywhere] dark:text-slate-400">
            {String(row.id)}
          </span>
          <span className="rounded bg-amber-50 px-1.5 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-950/40 dark:text-amber-200">
            2 with this label
          </span>
        </div>
      )}
    </div>
  );
}
